import ActiveController from '@/controller.active';

class companiesListController extends ActiveController{
  constructor(
    $location,
    $companies,
    $stateParams,
  ){
    'ngInject';
    super();
    this.$location = $location;
    this.$companies = $companies;
    this.companies   = this.$companies.collections.companies;
    this.$stateParams = $stateParams;

    this.loading = false;
    this.noData = false;

    this.tableConfiguration = {
			id: "companiesList",
			next_uri: false,
			limit: 25,
			search: "",
			cursor: 1,
		};
  }

  $onInit(scroll = false) {
		try {
			if (!this.loading) {
			  this.$location.path('/admin/companies');
			  this.companies = [];
			  this.noData = false;
				this.loading = true;
        return this.$companies.getCompanies(this.tableConfiguration)
          .then(() => {
            this.companies = this.$companies.collections.companies;
            if (this.companies.length === 0) {
              this.noData = true;
            }
            this.loading = false;
          });
			}
		} catch (e) {
			this.loading = false;
		}
	}

}

export default companiesListController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-list/companies-list.controller.js
 **/